module.exports = __webpack_public_path__ + "img/moodmix-logo.79b5b3a0.png";